import request from '@/utils/request'

import {
  serviceOptions,
  CardService,
  AccountService,
  ClientService,
  UserService,
  SwiperService,
  OrganizationUnitService,
  AuditLogService,
  CmsContentService,
  CmsCategoryService,
  SessionService,
  WechatUserinfoService,
  TenantSettingsService,
  RoleService,
  CardSkuService,
  ProjectService,
  PayOrderService,
  RefundLogService,
  AuditFlowService,
  AuditNodePreDefineService,
  IncomeStatisticsService,
  ReimbursementService,
  PayrollRequisitionService,
  ActivityService,
  ActivityApplyService,
  UserCardService,
  BaseCardService,
  ProjectPaymentsAndReceiptsService,
  ProtocolService,
  ProfitReportService,
  CardReportDetailService,
  PaymentCategoryService,
  DepartmentService,
  IncomeRecordService,
  AttachmentService,
  QuestionService,
  QuestionTopicService,
  PermissionDefinitionService,
  SalaryService,
  ProjectLedgerService,
  UserDiffCardService,
  IncomeSupplementService,
  TokenAuthService,
  ConfigurationService,
  SplitBillService,
  WechatMessageSubscribeService,
  StoreSplitAccountReportService
} from './appService'

import {Attachment} from './attachment';

serviceOptions.axios = request;

//const basrUrl = process.env.VUE_APP_BASE_API;


const guid = '00000000-0000-0000-0000-000000000000';


export default {
  auditFlow: AuditFlowService,
  auditNodePreDefine: AuditNodePreDefineService,
  auditLog: AuditLogService,
  account: AccountService,
  activity: ActivityService,
  activityApply: ActivityApplyService,
  client: ClientService,
  cmsContent: CmsContentService,
  cmsCategory: CmsCategoryService,
  card: CardService,
  baseCard: BaseCardService,
  cardSku: CardSkuService,
  userCard: UserCardService,
  cardReportDetail: CardReportDetailService,
  userDiffCard: UserDiffCardService,
  organizationUnit: OrganizationUnitService,
  department: DepartmentService,
  project: ProjectService,
  projectLedger: ProjectLedgerService,
  payOrder: PayOrderService,
  refundLog: RefundLogService,
  role: RoleService,
  session: SessionService,
  swiper: SwiperService,
  tenantSetting: TenantSettingsService,
  user: UserService,
  tokenAuth: TokenAuthService,
  wechatUserinfo: WechatUserinfoService,
  ProjectPaymentsAndReceiptses: ProjectPaymentsAndReceiptsService,
  // pays
  incomeStatistics: IncomeStatisticsService,
  reimbursement: ReimbursementService,
  payrollRequisition: PayrollRequisitionService,
  paymentCategoryService: PaymentCategoryService,
  incomeRecord: IncomeRecordService,
  incomeSupplement: IncomeSupplementService,
  attachment: AttachmentService,
  protocol: ProtocolService,
  profitReport: ProfitReportService,
  storeSplitAccountReport: StoreSplitAccountReportService,
  salary: SalaryService,
  attachmentService: AttachmentService,
  question: QuestionService,
  questionTopic: QuestionTopicService,
  permissionDefinition: PermissionDefinitionService,
  splitBill:SplitBillService,

  configuration:ConfigurationService,
  wechatMessageSubscribe:WechatMessageSubscribeService,

  guid
}
